// API Configuration with environment variable support
// Remove trailing slash if present to avoid double slashes
const getBaseUrl = () => {
  const url = import.meta.env.VITE_API_BASE_URL || 'https://api.2for1savings.com/public/api';
  return url.replace(/\/$/, ''); // Remove trailing slash
};

const API_BASE_URL = getBaseUrl();

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    USER: '/user',
    FORGET_PASSWORD: '/forget-password',
    FORGOT_PASSWORD_ADMIN: '/forgot-password-admin',
    PASSWORD_RESET: '/password-reset',
    PASSWORD_RESET_SUBMIT: '/password/reset',
  }
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_CONFIG.BASE_URL}${normalizedEndpoint}`;
};

// Helper function to build user-specific API URLs
export const buildUserApiUrl = (userId: number): string => {
  return buildApiUrl(`/users/${userId}`);
};


// Pre-built API URLs for common endpoints
export const API_URLS = {
  LOGIN: buildApiUrl(API_CONFIG.ENDPOINTS.LOGIN),
  LOGOUT: buildApiUrl(API_CONFIG.ENDPOINTS.LOGOUT),
  USER: buildApiUrl(API_CONFIG.ENDPOINTS.USER),
  FORGET_PASSWORD: buildApiUrl(API_CONFIG.ENDPOINTS.FORGET_PASSWORD),
  FORGOT_PASSWORD_ADMIN: buildApiUrl(API_CONFIG.ENDPOINTS.FORGOT_PASSWORD_ADMIN),
  PASSWORD_RESET: buildApiUrl(API_CONFIG.ENDPOINTS.PASSWORD_RESET),
  PASSWORD_RESET_SUBMIT: buildApiUrl(API_CONFIG.ENDPOINTS.PASSWORD_RESET_SUBMIT),
};

// Export for debugging
export const getApiConfig = () => ({
  baseUrl: API_CONFIG.BASE_URL,
  endpoints: API_CONFIG.ENDPOINTS,
  urls: API_URLS
}); 